<template>
  <div class="content-area">
    <label class="input-title">{{ component.label }}</label>
    <textarea
      :placeholder="component.placeholder"
      class="input-area"
    ></textarea>
  </div>
</template>
<script>
export default {
  name: 'TextArea',

  props: {
    component: {
      type: Object,
      required: true,
    },
  },
}
</script>
<style scoped>
.content-area {
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.input-title {
  font-weight: bold;
  /* font-size: 14px; */
  font-family: 'Rajdhani', sans-serif;
  color: #69739e;
  padding-left: 5px;
}
.input-area {
  background-color: #eeeeee;
  border: 1px solid #dddddd;
  border-radius: 8px;
  color: #69739e;
  padding: 10px;
  resize: none;
}
textarea::placeholder {
  color: #69739e;
}
textarea:focus {
  outline: none;
  box-shadow: none;
}
</style>
